import { __assign, __rest } from "tslib";
import React from 'react';
import classNames from 'classnames';
export function BuyIcon(props) {
    var _a;
    var className = props.className, type = props.type, htmlProps = __rest(props, ["className", "type"]);
    return (React.createElement("i", __assign({ className: classNames('buy-icon', (_a = {},
            _a["buy-icon-" + type] = typeof type !== 'undefined',
            _a), className) }, htmlProps)));
}
//# sourceMappingURL=BuyIcon.js.map